<template>
    <div class="page">
        <Headers></Headers>
        <div class="banner">
            <!-- 顶部标题 -->
            <div class="pdfPageTitle mg_t">
                <div class="pdfPageTitle-txt">
                    <span class="pdfPageTitle-txt__first">零碳运营</span>
                    <span class="pdfPageTitle-txt__second">(权重{{PdftStore.fromData.spaceEmissionZeroOperation?.weight}}%)</span>
                </div>
                <!-- <div class="pdfPageTitle-icon">
                    <img src="@/assets/img/page9.png">
                </div> -->
            </div>

            <!-- 顶部数据 -->
            <div class="top_box">
                <div class="left">
                    <div class="title mg_b">核查结论</div>
                    <div class="tx">{{PdftStore.fromData.spaceEmissionZeroOperation?.verificationConclusion}}</div>
                </div>
            </div>

            <!-- 明细 -->
            <div class="min_box">
                <div class="title">碳中和进程评级得分明细</div>
                <List :type=5  :id="'listPdfReport5'"/>
            </div>

            <!-- 数据图表 -->
            <div class="banner_box">
                <div class="left_box">
                    <div class="top_box_banner">
                        <div class="title">零碳运营得分：</div>
                        <div class="jindu" v-if="PdftStore.fromData.spaceEmissionZeroOperation">
                            <NewPro
                            :name="'page9progess'"
                            :centerNum="0"
                            :minScore="0"
                            :centerScore="100"
                            :leftScore="PdftStore.fromData.spaceEmissionZeroOperation?.updateScore"
                            :maxEmiss="'无措施'"
                            :minEmiss="'措施完整'"
                            :maxScore="100"
                            :rightMinScore="0"
                            :rightMaxScore="40"
                            :rightScore="20"
                            :rightMinTxt="''"
                            :rightMaxTxt="''"
                            />
                        </div>
                    </div>
                    <div class="title">在参评企业中的位置</div>
                    <div class="title_txt">超过8项措施并提供证据为“完善”，4-8项为“中等”，小于4项为“一般”</div>
                    <div class="ec_t" v-if="PdftStore.fromData.spaceEmissionZeroOperation">
                        <Elist1
                            :name="'elist3'"
                            :lineNum="[
                                {
                                    name:'一般',
                                    value:'1'
                                },
                                {
                                    name:'中等',
                                    value:'2'
                                },
                                {
                                    name:'完善',
                                    value:'3'
                                },
                            ]"
                            :lineHeight="'25px'"
                            :lineRadius="'25px'"
                            :imgId="PdftStore.fromData.orgInfo?.logoId"
                            :num="PdftStore.fromData.spaceEmissionZeroOperation?.ratingPosition"
                        />
                    </div>
                </div>
                <div class="right_box">
                    <div class="top_box_banner">
                        <div class="title">评分逻辑</div>
                        <div class="txt">{{PdftStore.fromData.spaceEmissionZeroOperation?.scoreStandard}}</div>
                    </div>
                    <div class="title">碳中和进程评级综合表现</div>
                    <div class="ec_t" v-if="PdftStore.fromData.spaceEmissionZeroOperation">
                        <Echarts :name="'page9echarts'" :type="'e'"/>
                    </div>
                </div>
            </div>
            <!-- 底部 -->
            <Bottoms/>
            <div class="flxed">07</div>
        </div>
    </div>
</template>

<script>
import { reactive, toRefs, onBeforeMount, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import Headers from '../components/headers.vue'
import Bottoms from '../components/bottoms.vue'
import List from '../components/list.vue'
import NewPro from '../components/newPro.vue'
import Elist1 from '../components/eList1.vue'
import Echarts from '../components/echarts.vue'
import { usePdftStore } from '@/store/pdf'
import { formatDateTimeYYmm, formatDateTimeYY } from '@/utils/date'
export default {
    name: 'page9',
    components:{Headers, Bottoms, List, NewPro, Elist1, Echarts},
    setup() {
        const data = reactive({
            xdata:{
                name:'',
                data:['一般','中等','完善']
            },
            ydata:{
                name:'',
                type:1
            },
            series:{
                data:[
                    {
                        value:26,
                        type:1,
                        name:'隆基股份隆基股份'
                    }, 
                    14, 
                    2
                ],
            },
        })
        //引入数据管理库
        const PdftStore = usePdftStore()
        const formatDateTimeYYmms = (str) => {
            return formatDateTimeYYmm(str)
        }
        const formatDateTimeYYs = (str) => {
            return formatDateTimeYY(str)
        }
        onBeforeMount(() => {})
        onMounted(() => {})
        return {
            PdftStore,
            formatDateTimeYYmms,
            formatDateTimeYYs,
            ...toRefs(data),
        }
    },
}

</script>
<style scoped lang='less'>
.mag_t{
    margin-top: 20px;
}
.margin_t{
    margin-top: 10px;
}
.page{
    width: 1512px;
    height: 2149px;
    margin: 0 auto;
    background: #FFFFFF;
    position: relative;
    .banner{
        width: 100%;
        padding: 0 130px;
        .mg_t{
            margin-top: 96px;
        }
        .flxed{
            position: absolute;
            right: 20px;
            bottom: 20px;
            font-size: 24px;
            font-weight: 400;
            color: #333333;
            line-height: 33px;
        }
        .top_box{
            margin-top: 50px;
            display: flex;
            justify-content: stretch;
            .title{
                font-size: 28px;
                font-weight: bold;
                color: #333333;
                line-height: 42px;
            }
            .left{
                width: 100%;
                // padding-right: 40px;
                // border-right: 1px dashed #C5C5C6;
                flex: 1;
                .mg_b{
                    margin-bottom: 20px;
                }
                .txt{
                    font-size: 32px;
                    font-weight: 500;
                    line-height: 36px;
                    color: #333333;
                    white-space: normal;
                    word-wrap: break-word;
                }
                .tx{
                    margin-top: 15px;
                    font-size: 16px;
                    line-height: 24px;
                    text-align: justify;
                    font-weight: 400;
                    color: #666666;
                    white-space: normal;
                    word-wrap: break-word;
                }
            }
            .right{
                width: calc(100% - 670px);
                padding-left: 40px;
                flex: 1;
                .txt{
                    font-size: 16px;
                    font-weight: 400;
                    text-align: justify;
                    color: #333333;
                    line-height: 24px;
                    margin-top: 23px;
                    white-space: normal;
                    word-wrap: break-word;
                }
            }
            
        }
        .min_box{
            margin-top: 55px;
            font-size: 24px;
            font-weight: 500;
            color: #333333;
            line-height: 42px;
            .title{
                margin-bottom: 33px;
                font-weight: bold;
            }
        }
    }
}
.banner_box{
    display: flex;
    width: 100%;
    height: 900px;
    margin-top: 30px;
    justify-content: stretch;
    .left_box{
        width: 670px;
        padding-right: 40px;
        border-right: 1px dashed #C5C5C6;
        flex: 1;
    }
    .right_box{
        width: calc(100% - 670px);
        flex: 1;
        padding-left: 40px;
    }
    .top_box_banner{
        height: 430px;
    }
    .title{
        font-size: 28px;
        font-weight: bold;
        color: #333333;
        line-height: 42px;
    }
    .title_txt{
        font-size: 14px;
        font-weight: 500;
        color: #999999;
        line-height: 24px;
    }
    .jindu{
        height: calc(350px - 42px);
        width: 100%;
        display: flex;
        align-items: center;
    }
    .mg_top{
        margin-top: 90px;
    }
    .ec_t{
        margin-top: 30px;
        width: 100%;
        height: 400px;
    }
    .txt{
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        text-align: justify;
        line-height: 24px;
        margin-top: 10px;
        white-space: normal;
        word-wrap: break-word;
    }
    .txt_s{
        color: #999999;
    }
}
</style>